import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";

import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { filter } from "rxjs/operators";

import * as moment from "moment";
import * as _ from "lodash";
import { Loan } from "../../../models/loan.model";
import { UserService } from "../../../@core/services/user.service";
import { LoanService } from "../../../services/loan.service";
import { DialogLoanComponent } from "../../dialogs/dialog-loan/dialog-loan.component";
import Shop from "../../../models/shop.model";
import { User } from "../../../@core/data/users";
import { Catalog } from "../../../models/product.model";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";

@Component({
  selector: "ngx-view-loan-cover",
  styleUrls: ["./view-loan-cover.component.scss"],
  templateUrl: "./view-loan-cover.component.html",
})
export class ViewLoanCoverComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() loan: Loan;
  @Input() mode?: string = ""; //view
  @Input() isMore? = false;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() groupLoans?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];

  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isMobile = false;

  constructor(
    public userService: UserService,
    private loanService: LoanService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId;
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  get remindTypeName(): string {
    let str = "";
    const remindPaidNumber = this.loan.remindPaidNumber
      ? this.loan.remindPaidNumber
      : 1;

    str += remindPaidNumber === 1 ? "hằng " : "mỗi " + remindPaidNumber + " ";

    switch (this.loan.remindType) {
      case "day":
        str += "ngày";
        break;
      case "week":
        str += "tuần";
        break;
      case "month":
      default:
        str += "tháng";
        break;
      case "year":
        str += "năm";
        break;
    }

    return str;
  }

  ngOnInit() {
    this.loan.issueDate = this.loan.issueDate
      ? moment(this.loan.issueDate).toDate()
      : new Date();

    if (this.loan.customer) {
      this.loan.customer.cardIdDate = this.loan.customer?.cardIdDate
        ? convertTimestamp(this.loan.customer.cardIdDate)
        : new Date();
    } else {
      this.loan.customer = {
        fullName: "",
        address: "",
        mobile: "",
        cardId: "",
        cardIdDate: new Date(),
      };
    }

    // this.loan.customer.cardIdDate = this.loan.customer?.cardIdDate
    //   ? moment(this.loan.customer.cardIdDate).toDate()
    //   : new Date();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent(value) {
    this.isMore = value;
  }

  viewDetail(item) {
    if (this.mode === "remind") {
      this.getLoan(item.id);
    } else if (this.mode !== "view") {
      this.openDialogLoan(item);
    }
  }

  private getLoan(id) {
    this.loading = true;
    this.loanService
      .getLoan(this.shopId, id)
      .then((doc) => {
        console.log("getLoan:", doc.data());

        if (doc.exists) {
          let loan: Loan = new Loan();
          loan = doc.data();
          loan.id = id;
          loan.createdOn = convertTimestamp(loan.createdOn);
          loan.issueDate = convertTimestamp(loan.issueDate);
          loan.remindDate = convertTimestamp(loan.remindDate);
          loan.updatedOn = convertTimestamp(loan.updatedOn);

          loan.customer.cardIdDate = loan.customer.cardIdDate
            ? convertTimestamp(loan.customer.cardIdDate)
            : new Date();

          this.openDialogLoan(loan);
        }
        this.loading = false;
      })
      .catch((err) => {
        console.log("getLoan/err:", err);
        this.loading = false;
      });
  }

  private openDialogLoan(item: Loan) {
    const loan = _.clone(item);
    this.dialogService
      .open(DialogLoanComponent, {
        context: {
          header: "Tạo phiếu cầm đồ",
          mode: "edit",
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          loan: loan,
          groupLoans: this.groupLoans,
          categories: this.categories,
          colors: this.colors,
          menu: "detail",
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          if (value.isDeleted) {
            item = value;
            this.onDelete.emit(value);
          } else {
            this.onEdit.emit(value);
          }
        }
      });
  }
}
